import React from 'react';
import HelpContactsComponent from './help-contacts.component.jsx';

function HelpContacts() {
    return <HelpContactsComponent />;
}

export default HelpContacts;
